import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/spotipy.png'


const _withScopeId = n => (_pushScopeId("data-v-186bbf54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Spotipy Logo"
  }),
  /*#__PURE__*/_createElementVNode("h3", null, [
    /*#__PURE__*/_createTextVNode("Spotipy "),
    /*#__PURE__*/_createElementVNode("small", null, "®")
  ])
], -1))
const _hoisted_2 = { class: "sidebar__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SideLink = _resolveComponent("SideLink")!

  return (_openBlock(), _createElementBlock("aside", null, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_SideLink, {
        to: "home",
        icon: "fas fa-home",
        title: "Home"
      }),
      (_ctx.userLoggedIn)
        ? (_openBlock(), _createBlock(_component_SideLink, {
            key: 0,
            to: "upload",
            icon: "fa-solid fa-plus",
            title: "Upload"
          }))
        : _createCommentVNode("", true),
      (_ctx.userLoggedIn)
        ? (_openBlock(), _createBlock(_component_SideLink, {
            key: 1,
            to: "manage",
            icon: "fa-solid fa-pen-to-square",
            title: "Manage"
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_SideLink, {
        to: "about",
        icon: "fa-solid fa-tablet-screen-button",
        title: "About Apps"
      })
    ])
  ]))
}